import { render } from "./CasterEventsStatsPage.vue?vue&type=template&id=02f7927e&scoped=true"
import script from "./CasterEventsStatsPage.vue?vue&type=script&lang=js"
export * from "./CasterEventsStatsPage.vue?vue&type=script&lang=js"

import "./CasterEventsStatsPage.vue?vue&type=style&index=0&id=02f7927e&scoped=true&lang=css"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02f7927e"]])

export default __exports__